import { useUpdateOrgDetails } from '../hooks/useUpdateOrgDetails';
import { Header } from '../types';

interface SaveHeaderParams {
  selectedHeader: Header;
  updatedHeaders: Header[];
  toRadOrganizationId?: string;
}

export const useSaveHeaderService = () => {
  const { updateOrgDetails, loading, error } = useUpdateOrgDetails();

  const saveHeader = async ({ selectedHeader, updatedHeaders, toRadOrganizationId }: SaveHeaderParams) => {
    if (!selectedHeader) {
      throw new Error('Please select a header first');
    }

    const headerToUpdate = updatedHeaders.find(h => h.requestNumber === selectedHeader.requestNumber) || selectedHeader;
    
    // Use TO RAD organizationId if provided, otherwise fall back to header's toSite
    const whidValue = toRadOrganizationId || headerToUpdate.toSite;
    
    if (!whidValue) {
      throw new Error('Please select a To Site or To RAD before saving');
    }

    const result = await updateOrgDetails({
      p_return_header_id: selectedHeader.requestNumber,
      p_whid: whidValue,
      p_reopen_order: "N"
    });

    if (!result || !result.success) {
      throw new Error(result?.return_message || 'Unknown error');
    }

    return {
      success: true,
      message: result.return_message,
      updatedToSite: headerToUpdate.toSite
    };
  };

  return {
    saveHeader,
    loading,
    error
  };
};